import { Box } from '@mui/material';
import { AccessDeniedTileInfo } from 'app/home/index.functions';
import React, { useState } from 'react';
import useBundleTranslation from 'i18n';
import DiscoverableDenyPage from 'app/auth/deny/discoverable';
import { Popup } from 'components/common/popup/Popup';

export default function AccessDeniedPopup({
    accessDeniedTile,
    setAccessDeniedPopupTile,
}: {
    accessDeniedTile?: AccessDeniedTileInfo;
    setAccessDeniedPopupTile: (tile: AccessDeniedTileInfo | null) => void;
}) {
    const { t } = useBundleTranslation('app/home');
    const [showPopup, setShowPopup] = useState(true);

    const onPopupHide = () => {
        setShowPopup(false);
        setAccessDeniedPopupTile(null);
    };

    return showPopup && accessDeniedTile ? (
        <Popup
            settings={{
                title: t('access_denied'),
                noButtons: true,
                needTranslation: false,
            }}
            maxWidth="popupXl"
            onHide={onPopupHide}
            open
        >
            <Box sx={{ pt: 1 }}>
                <DiscoverableDenyPage
                    elementId={Number(accessDeniedTile.element_id)}
                    segmentValueId={Number(accessDeniedTile.segment_value_id)}
                    onClose={onPopupHide}
                    isPopup
                />
            </Box>
        </Popup>
    ) : null;
}
